import Image from 'next/image'

import { Response_WorkDetailSeason } from '@/api/@types'

export type WorkTitleProps = {
  workDetailName: string
  projectName: string
  projectSeason: Response_WorkDetailSeason | undefined
}

export const WorkTitle = ({
  workDetailName,
  projectName,
  projectSeason,
}: WorkTitleProps) => {
  return (
    <section aria-labelledby="work-title" className="flex">
      <div className="w-[64px] h-[96px]">
        <Image
          src={projectSeason?.thumbnailUrl ?? ''}
          alt={`${projectSeason?.name ?? ''}のサムネイル`}
          width={64}
          height={96}
          className="rounded-[8px]"
        />
      </div>
      <div className="flex-1 ml-8">
        <h1 id="work-title" className="mb-4 text-md font-bold">
          {workDetailName}({projectName})
        </h1>
        <p className="text-xl font-bold">{projectSeason?.name ?? ''}</p>
        <div className="mt-8 space-x-8">
          {projectSeason?.categoriesAndTags?.map(tag => (
            <span key={tag} className="text-xs font-bold">
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </section>
  )
}
